module.exports = __webpack_public_path__ + "img/id-card.d70f3f16.svg";